// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const miraidon_aquatic_mode: PokeData = {
  "id": 10270,
  "name": "miraidon-aquatic-mode",
  "height": 28,
  "weight": 2400,
  "base_experience": 335,
  "types": [
    PokeType.ELECTRIC,
    PokeType.DRAGON
  ],
  "api_moves": [
    "hyper-beam",
    "thunder-shock",
    "thunder",
    "agility",
    "outrage",
    "dragon-breath",
    "mirror-coat",
    "charge",
    "overheat",
    "metal-sound",
    "shock-wave",
    "dragon-pulse",
    "discharge",
    "parabolic-charge",
    "electric-terrain",
    "electro-drift"
  ],
  "moves": [
    "thunder-shock",
    "thunder",
    "outrage",
    "dragon-breath",
    "metal-sound",
    "dragon-pulse",
    "electric-terrain",
    "draco-meteor",
    "dragon-vortex",
    "electric-wrath",
    "dragon-claw",
    "dragon-fang",
    "dragon-rush"
  ],
  "evolution_chain": {
    "id": 536,
    "item": null,
    "species": [
      {
        "name": "miraidon",
        "order": 999,
        "types": [
          PokeType.ELECTRIC,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 111,
    "speed": 144,
    "ability_power": 144
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
